import { useEffect, useRef, useState } from "react";
import { db } from "../../lib/api";
import { invalidate } from "../../lib/hooks";
import { navigate, useRoute } from "../../lib/router";
import { PageHead } from "../../components/Shell";
import { Panel } from "../../components/ui";

/** Google sends you back here after you allow access; we finish the connection and go back to Settings. */
export default function GoogleCallback() {
  const { query } = useRoute();
  const [msg, setMsg] = useState("Finishing the connection with Google…");
  const [ok, setOk] = useState<boolean | null>(null);
  const [back, setBack] = useState("/settings/automations");
  const once = useRef(false);
  useEffect(() => {
    if (once.current) return; once.current = true;
    const code = query.get("code"), state = query.get("state"), error = query.get("error");
    if (error || !code || !state) { setOk(false); setMsg(error === "access_denied" ? "You didn't allow access, so nothing was connected." : "Google didn't send a code back. Try Connect again."); return; }
    if (state.startsWith("c_")) {   // Phone contacts connection
      db.rpc<{ ok: boolean; account: string | null }>("contacts_connect", { p_code: code, p_state: state })
        .then((r) => { setOk(true); setBack("/settings/phone-contacts"); setMsg(`Connected to Google Contacts${r.account ? ` (${r.account})` : ""}. Now set your rules: which label goes to which list.`); invalidate("ref:"); })
        .catch((e) => { setOk(false); setBack("/settings/phone-contacts"); setMsg(String(e.message ?? e)); });
      return;
    }
    db.rpc<{ ok: boolean; calendar: string }>("google_connect", { p_code: code, p_state: state })
      .then((r) => { setOk(true); setMsg(`Connected to ${r.calendar}. Meetings you book in the CRM will now appear in your Google Calendar, and Calendly will treat that time as busy.`); invalidate("auto:"); db.rpc("google_sync_now").catch(() => undefined); })
      .catch((e) => { setOk(false); setMsg(String(e.message ?? e)); });
  }, [query]);
  return (
    <>
      <PageHead title="Google" />
      <Panel><div className="panel-body">
        <p style={{ marginTop: 0, color: ok === false ? "var(--alert)" : undefined }}>{msg}</p>
        {ok !== null && <button className="btn primary" onClick={() => navigate(back)}>{back === "/settings/automations" ? "Back to Emails & reminders" : "Back to Phone contacts"}</button>}
      </div></Panel>
    </>
  );
}
